import React from "react";

export default function NotAuthorizedPage() {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>אין לך הרשאה לדף זה</h1>
      <p>אנא פנה למנהל המערכת במקרה הצורך.</p>
    </div>
  );
}
